/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_confirm_extraction_for_erp_invoices_confirm_extraction_for_erp_post } from '../models/Body_confirm_extraction_for_erp_invoices_confirm_extraction_for_erp_post';
import type { Body_patch_statuses_invoices_statuses_patch } from '../models/Body_patch_statuses_invoices_statuses_patch';
import type { Body_reject_invoice_batch_invoices_reject_batch_post } from '../models/Body_reject_invoice_batch_invoices_reject_batch_post';
import type { Body_update_batch_id_invoices_set_batch_patch } from '../models/Body_update_batch_id_invoices_set_batch_patch';
import type { EmailAttachmentRead } from '../models/EmailAttachmentRead';
import type { InvoiceAgeGroup } from '../models/InvoiceAgeGroup';
import type { InvoiceComplete } from '../models/InvoiceComplete';
import type { InvoiceCompleteNoValidation } from '../models/InvoiceCompleteNoValidation';
import type { InvoiceDetailRead } from '../models/InvoiceDetailRead';
import type { InvoiceErpSubmissionRead } from '../models/InvoiceErpSubmissionRead';
import type { InvoiceExceptionsHistoryCreate } from '../models/InvoiceExceptionsHistoryCreate';
import type { InvoiceIds } from '../models/InvoiceIds';
import type { InvoiceItemCreate } from '../models/InvoiceItemCreate';
import type { InvoiceItemRead } from '../models/InvoiceItemRead';
import type { InvoiceMetadataCreate } from '../models/InvoiceMetadataCreate';
import type { InvoiceMetadataRead } from '../models/InvoiceMetadataRead';
import type { InvoiceParsingContainer } from '../models/InvoiceParsingContainer';
import type { InvoiceRejectionCreate } from '../models/InvoiceRejectionCreate';
import type { InvoicesAITLRead } from '../models/InvoicesAITLRead';
import type { InvoicesAllRead } from '../models/InvoicesAllRead';
import type { InvoiceStatistics } from '../models/InvoiceStatistics';
import type { InvoiceStatusChangeRead } from '../models/InvoiceStatusChangeRead';
import type { InvoiceStatusPatchCreate } from '../models/InvoiceStatusPatchCreate';
import type { InvoiceXftSubmissionRead } from '../models/InvoiceXftSubmissionRead';
import type { MarkInvoiceRetainedRequest } from '../models/MarkInvoiceRetainedRequest';
import type { MarkInvoiceRetainedResponse } from '../models/MarkInvoiceRetainedResponse';
import type { ProcessingBatchRequest } from '../models/ProcessingBatchRequest';
import type { RetentionInvoiceListResponse } from '../models/RetentionInvoiceListResponse';
import type { StatusGroup } from '../models/StatusGroup';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InvoiceService {

    /**
     * Create Invoice Metadata
     * @param opco
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static createInvoiceMetadataInvoicesCreatePost(
        opco: string,
        requestBody: InvoiceMetadataCreate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceMetadataRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/create',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'opco': opco,
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Request Invoice Metadata
     * @param opco
     * @param requestBody
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static requestInvoiceMetadataInvoicesRegisterPost(
        opco: string,
        requestBody: InvoiceMetadataCreate,
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceMetadataRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/register',
            headers: {
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'opco': opco,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Invoice Detail
     * @param id
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceDetailRead Successful Response
     * @throws ApiError
     */
    public static getInvoiceDetailInvoicesIdCheckOutPost(
        id: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceDetailRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/{id}/check_out',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Email Attachments
     * @param id
     * @returns EmailAttachmentRead Successful Response
     * @throws ApiError
     */
    public static getEmailAttachmentsInvoicesEmailAttachmentsGet(
        id: number,
    ): CancelablePromise<Array<EmailAttachmentRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/email_attachments',
            query: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Invoice Statistics
     * @param queueId
     * @param accessToken Optional SSO Bearer token
     * @param arrowId
     * @param invoiceNumber
     * @param assignedUserEmail
     * @param supplierName
     * @param supplierSite
     * @param currency
     * @param queueName
     * @param businessUnit
     * @param invoiceAge
     * @param invoiceStartDate
     * @param invoiceEndDate
     * @param glStartDate
     * @param glEndDate
     * @param invoiceAmountMin
     * @param invoiceAmountMax
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceStatistics Successful Response
     * @throws ApiError
     */
    public static getInvoiceStatisticsInvoicesInvoiceStatisticsGet(
        queueId?: (number | null),
        accessToken?: string,
        arrowId?: (number | null),
        invoiceNumber?: (string | null),
        assignedUserEmail?: (string | null),
        supplierName?: (string | null),
        supplierSite?: (string | null),
        currency?: (string | null),
        queueName?: (string | null),
        businessUnit?: (string | null),
        invoiceAge?: (InvoiceAgeGroup | null),
        invoiceStartDate?: (string | null),
        invoiceEndDate?: (string | null),
        glStartDate?: (string | null),
        glEndDate?: (string | null),
        invoiceAmountMin?: (number | null),
        invoiceAmountMax?: (number | null),
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceStatistics> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/invoice_statistics',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'queue_id': queueId,
                'access_token': accessToken,
                'arrow_id': arrowId,
                'invoice_number': invoiceNumber,
                'assigned_user_email': assignedUserEmail,
                'supplier_name': supplierName,
                'supplier_site': supplierSite,
                'currency': currency,
                'queue_name': queueName,
                'business_unit': businessUnit,
                'invoice_age': invoiceAge,
                'invoice_start_date': invoiceStartDate,
                'invoice_end_date': invoiceEndDate,
                'gl_start_date': glStartDate,
                'gl_end_date': glEndDate,
                'invoice_amount_min': invoiceAmountMin,
                'invoice_amount_max': invoiceAmountMax,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Invoice History
     * @param id
     * @returns InvoiceStatusChangeRead Successful Response
     * @throws ApiError
     */
    public static getInvoiceHistoryInvoicesIdHistoryGet(
        id: number,
    ): CancelablePromise<Array<InvoiceStatusChangeRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/{id}/history',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Revision
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceItemRead Successful Response
     * @throws ApiError
     */
    public static createRevisionInvoicesCreateRevisionPut(
        requestBody: InvoiceItemCreate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceItemRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/invoices/create_revision',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Filter Dropdown
     * @param statusGroup
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getFilterDropdownInvoicesFilterDropdownGet(
        statusGroup: StatusGroup,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Record<string, Array<any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/filter-dropdown',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'status_group': statusGroup,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get All Invoices
     * @param statusGroup
     * @param pageNum Page number for pagination, starting from 0
     * @param limit Number of invoices per page, must be 1 or greater
     * @param sortBy Field to sort by
     * @param sortOrder Sort order, asc or desc
     * @param accessToken Optional SSO Bearer token
     * @param arrowId
     * @param invoiceNumber
     * @param assignedUserEmail
     * @param supplierName
     * @param supplierSite
     * @param currency
     * @param queueName
     * @param businessUnit
     * @param invoiceAge
     * @param invoiceStartDate
     * @param invoiceEndDate
     * @param glStartDate
     * @param glEndDate
     * @param invoiceAmountMin
     * @param invoiceAmountMax
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoicesAllRead Successful Response
     * @throws ApiError
     */
    public static getAllInvoicesInvoicesAllGet(
        statusGroup: StatusGroup,
        pageNum?: (number | null),
        limit?: (number | null),
        sortBy: string = 'invoice_date',
        sortOrder: 'asc' | 'desc' = 'desc',
        accessToken?: string,
        arrowId?: (number | null),
        invoiceNumber?: (string | null),
        assignedUserEmail?: (string | null),
        supplierName?: (string | null),
        supplierSite?: (string | null),
        currency?: (string | null),
        queueName?: (string | null),
        businessUnit?: (string | null),
        invoiceAge?: (InvoiceAgeGroup | null),
        invoiceStartDate?: (string | null),
        invoiceEndDate?: (string | null),
        glStartDate?: (string | null),
        glEndDate?: (string | null),
        invoiceAmountMin?: (number | null),
        invoiceAmountMax?: (number | null),
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<InvoicesAllRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/all',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'status_group': statusGroup,
                'page_num': pageNum,
                'limit': limit,
                'sort_by': sortBy,
                'sort_order': sortOrder,
                'access_token': accessToken,
                'arrow_id': arrowId,
                'invoice_number': invoiceNumber,
                'assigned_user_email': assignedUserEmail,
                'supplier_name': supplierName,
                'supplier_site': supplierSite,
                'currency': currency,
                'queue_name': queueName,
                'business_unit': businessUnit,
                'invoice_age': invoiceAge,
                'invoice_start_date': invoiceStartDate,
                'invoice_end_date': invoiceEndDate,
                'gl_start_date': glStartDate,
                'gl_end_date': glEndDate,
                'invoice_amount_min': invoiceAmountMin,
                'invoice_amount_max': invoiceAmountMax,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Processing Batch
     * @param requestBody
     * @param currentOpco
     * @param batchId
     * @param reprocessAll
     * @param maxBatchSize
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceParsingContainer Successful Response
     * @throws ApiError
     */
    public static getProcessingBatchInvoicesExtractBatchPost(
        requestBody: ProcessingBatchRequest,
        currentOpco?: (string | null),
        batchId?: (string | null),
        reprocessAll: boolean = false,
        maxBatchSize: number = 20,
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceParsingContainer> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/extract_batch',
            headers: {
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'current_opco': currentOpco,
                'batch_id': batchId,
                'reprocess_all': reprocessAll,
                'max_batch_size': maxBatchSize,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Post Exception
     * @param id
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static postExceptionInvoicesIdExceptionHistoryPost(
        id: number,
        requestBody: Array<InvoiceExceptionsHistoryCreate>,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceMetadataRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/{id}/exception_history',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Status
     * @param id
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static patchStatusInvoicesIdStatusPatch(
        id: number,
        requestBody: InvoiceStatusPatchCreate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceMetadataRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/invoices/{id}/status',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Statuses
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static patchStatusesInvoicesStatusesPatch(
        requestBody: Body_patch_statuses_invoices_statuses_patch,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<InvoiceMetadataRead>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/invoices/statuses',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Update Statuses
     * Bulk update invoice statuses. This replaces direct SQL UPDATE.
     * @param status
     * @param statusGroup
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static bulkUpdateStatusesInvoicesStatusesBulkPatch(
        status: string,
        statusGroup: string,
        requestBody: Array<number>,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/invoices/statuses/bulk',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'status': status,
                'status_group': statusGroup,
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Export And Close Invoice Items
     * Export invoice items for ERP and close them (set is_active=False).
     * This replaces the stored procedure export_and_close_invoice_items.
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportAndCloseInvoiceItemsInvoicesExportAndClosePost(
        requestBody: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/export_and_close',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reject Invoice
     * @param id
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static rejectInvoiceInvoicesIdRejectPost(
        id: number,
        requestBody: InvoiceRejectionCreate,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceMetadataRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/{id}/reject',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reject Invoice Batch
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static rejectInvoiceBatchInvoicesRejectBatchPost(
        requestBody: Body_reject_invoice_batch_invoices_reject_batch_post,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<InvoiceMetadataRead>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/reject_batch',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Submit To Erp
     * @param id
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceErpSubmissionRead Successful Response
     * @throws ApiError
     */
    public static submitToErpInvoicesIdExtractForErpPost(
        id: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceErpSubmissionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/{id}/extract_for_erp',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Submit To Xft
     * Extracts invoice for submission to XFT.
     *
     * Different information is required for XFT, so this endpoint
     * is separate from the ERP submission endpoint.
     * @param id
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceXftSubmissionRead Successful Response
     * @throws ApiError
     */
    public static submitToXftInvoicesIdExtractForXftPost(
        id: number,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceXftSubmissionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/{id}/extract_for_xft',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Confirm Extraction For Erp
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static confirmExtractionForErpInvoicesConfirmExtractionForErpPost(
        requestBody: Body_confirm_extraction_for_erp_invoices_confirm_extraction_for_erp_post,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<InvoiceMetadataRead>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/confirm_extraction_for_erp',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Complete Invoice
     * @param id
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static completeInvoiceInvoicesIdCompletePost(
        id: number,
        requestBody: InvoiceComplete,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceMetadataRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/{id}/complete',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Supplier Invoices
     * @param supplierSiteId
     * @param limit
     * @param offset
     * @returns InvoicesAITLRead Successful Response
     * @throws ApiError
     */
    public static getSupplierInvoicesInvoicesSupplierSiteIdSupplierInvoicesGet(
        supplierSiteId: number,
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<Array<InvoicesAITLRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/{supplier_site_id}/supplier_invoices',
            path: {
                'supplier_site_id': supplierSiteId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Complete No Validate Invoice
     * @param id
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static completeNoValidateInvoiceInvoicesIdCompleteNoValidationPost(
        id: number,
        requestBody: InvoiceCompleteNoValidation,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<InvoiceMetadataRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/{id}/complete_no_validation',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Check Duplicate Invoice
     * @param id
     * @param internalOnly
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static checkDuplicateInvoiceInvoicesIdDuplicateCheckGet(
        id: number,
        internalOnly: boolean = true,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/{id}/duplicate_check',
            path: {
                'id': id,
            },
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'internal_only': internalOnly,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Batch Id
     * @param batchId
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoiceMetadataRead Successful Response
     * @throws ApiError
     */
    public static updateBatchIdInvoicesSetBatchPatch(
        batchId: string,
        requestBody: Body_update_batch_id_invoices_set_batch_patch,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<InvoiceMetadataRead>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/invoices/set_batch',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'batch_id': batchId,
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Invoices By Ids
     * @param requestBody
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns InvoicesAllRead Successful Response
     * @throws ApiError
     */
    public static getInvoicesByIdsInvoicesByIdsPost(
        requestBody: InvoiceIds,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<InvoicesAllRead>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/by-ids',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Retention Eligible Invoices
     * Get invoices eligible for data retention based on OpCo-specific retention days.
     * Only accessible by SERVICE role.
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns RetentionInvoiceListResponse Successful Response
     * @throws ApiError
     */
    public static getRetentionEligibleInvoicesInvoicesRetentionEligibleGet(
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<RetentionInvoiceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/retention/eligible',
            headers: {
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Mark Invoice As Retained
     * Mark an invoice as retained (data_retention = true).
     * Only accessible by SERVICE role.
     * @param requestBody
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns MarkInvoiceRetainedResponse Successful Response
     * @throws ApiError
     */
    public static markInvoiceAsRetainedInvoicesRetentionMarkPatch(
        requestBody: MarkInvoiceRetainedRequest,
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<MarkInvoiceRetainedResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/invoices/retention/mark',
            headers: {
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
